import { render, staticRenderFns } from "./DiagnosticTest.vue?vue&type=template&id=1430bb4f&scoped=true&"
var script = {}
import style0 from "./DiagnosticTest.vue?vue&type=style&index=0&id=1430bb4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1430bb4f",
  null
  
)

export default component.exports